import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { CardDb } from '../redux/cardDbSlice';

const useOneCardDb = (cardId: string | undefined) : CardDb | undefined => {
  const cardDb = useSelector((state: RootState) => state.cardDb);
  const value = cardId ? cardDb.cards[cardId] : undefined;

  return value;
}

export default useOneCardDb;
